import { createTransform } from "redux-persist";

type SliceState = Record<string, unknown>;

export const stripControllerBulk = (inboundState: SliceState): SliceState => ({
  ...inboundState,
  adminList: [], // this contains so much data it hits localStorage size limits
  midnightValues: {},
});

// by not persisting the email address, we force GuardComponent to check the login every time the app is loaded
// `fetching` must not persist either: a login in flight at persist time would
// rehydrate as fetching:true with nothing to ever clear it, leaving the Login
// button permanently disabled with a spinner (review #14).
export const stripAuthEmail = (inboundState: SliceState): SliceState => ({
  ...inboundState,
  email: undefined,
  fetching: false,
});

export const stripRegionGeojson = (
  inboundState: SliceState & { regions: Array<Record<string, unknown>> },
): SliceState & { regions: Array<Record<string, unknown>> } => ({
  ...inboundState,
  regions: inboundState.regions.map((region) => ({ ...region, geojson: null })),
});

export const persistTransforms = [
  createTransform(stripAuthEmail, undefined, { whitelist: ["user"] }),
  createTransform(stripRegionGeojson, undefined, { whitelist: ["settings"] }),
  createTransform(stripControllerBulk, undefined, {
    whitelist: ["controllers"],
  }),
];
